import React, {lazy, FC, Suspense} from 'react'
import {Route, Routes, Navigate} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {Genera_sessioneVR} from '../pages/genera_sessionevr/Genera_sessioneVR'
import {Storico_sessioniVR} from '../pages/storico_sessioni/Storico_sessioni'
import {Storico_risultati} from '../pages/storico_risultati/Storico_risultati'
import {Storico_risultati_multiplayer} from '../pages/storico_risultati_multiplayer/Storico_risultati_multiplayer'
import {GestioneUtenti} from '../pages/console_admin/Gestione_utenti'
import {WithChildren} from '../../_metronic/helpers'
import {Login} from '../modules/auth/components/Login'

const PrivateRoutes = () => {
  const AccountPage = lazy(() => import('../modules/accounts/AccountPage'))
  const UsersPage = lazy(() => import('../modules/apps/user-management/UsersPage'))

  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* Redirect to Dashboard after success login/registartion */}
        <Route path='auth/*' element={<Navigate to='/dashboard' />} />
        {/* Pages */}
        <Route path='dashboard' element={<DashboardWrapper />} />
        <Route path='login' element={<Login />} />
        <Route path='genera-sessione-vr' element={<SuspensedView><Genera_sessioneVR /></SuspensedView>} />
        <Route path='storico-sessioni-vr' element={<SuspensedView><Storico_sessioniVR /></SuspensedView>} />
        <Route path='storico-risultati-individuale' element={<SuspensedView><Storico_risultati /></SuspensedView>} />
        <Route path='storico-risultati-cooperativo' element={<SuspensedView><Storico_risultati_multiplayer /></SuspensedView>} />
        <Route path='gestione-utenti' element={<GestioneUtenti />} />
        {/* Lazy Modules */}
        <Route
          path='crafted/account/*'
          element={
            <SuspensedView>
              <AccountPage />
            </SuspensedView>
          }
        />
        <Route
          path='apps/user-management/*'
          element={
            <SuspensedView>
              <UsersPage />
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404' />} />
      </Route>
    </Routes>
  )
}

const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = '#0D6C6D'
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 5,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export {PrivateRoutes}
